import React from "react"

import Status from "../../../../../../model2/status/status"
import {SortDirection} from "../../../../../../data-structures/sort"
import {ColorPalette} from "../../../../../color-coding/color-coding"
import HintPopover from "../../../../../../gd-ui/hint-popover/hint-popover"

type StatusCount = {
    status  : Status
    count   : number
}

type StatusSegment = {
    color       : number
    percentage  : number
}

type Props = {
    className?  : string

    data        : Record<ID, number>
}

// const debug = "StatusSummaryBar"
const debug = false

export default function StatusSummaryBar(props: Props) {
    const statusCounts: StatusCount[] = []
    _.mapValues(props.data, (value, id) => {
        statusCounts.push({
            status  : gd.session.statuses.get(id),
            count   : value
        })
    })

    const sortedStatusCounts = _.orderBy(statusCounts, (statusEntry: StatusCount) => {
            return statusEntry.status.systemStatus
        }, SortDirection.ASC
    )

    const totalCount = _.reduce(sortedStatusCounts, (sum, entry) => {
        return sum + entry.count
    }, 0)

    const statusSegments: StatusSegment[] = []
    let accumulatedPercentage   = 0
    let hintText                = ""

    _.map(sortedStatusCounts, (entry, key) => {
        let segmentPercentage: number

        // Ensures 100% final fill, last segment covers remainder
        if (key === sortedStatusCounts.length - 1) {
            segmentPercentage = 100 - accumulatedPercentage
        } else {
            segmentPercentage = totalCount > 0 ? Math.floor((100 * entry.count) / totalCount) : 0
        }

        accumulatedPercentage += segmentPercentage

        statusSegments.push({
            color       : entry.status.color,
            percentage  : segmentPercentage
        })

        hintText += '{0}: {1} \\n'.f(entry.status.name, entry.count)
    })

    debug && console.log(debug, "render", statusSegments)

    const classes = Classes("flex-row-left-center overflow-hidden border-radius-4 w-100p h-15", props.className)

    return (
        <div className={classes}>
            {_.map(statusSegments, (segment, key) => {
                const style = {
                    height          : "100%",
                    width           : '{0}%'.f(segment.percentage),
                    backgroundColor : gd.skin.colors.lightColor({
                        colorNumber     : segment.color,
                        corePalette     : ColorPalette.STATUS
                    })
                }
                return <div key={key} style={style}/>
            })}

            <HintPopover
                hint        = {hintText}
                multiline   = {true}
            />
        </div>
    )
}
